/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_Duplicate_NameInputs */



/**
* | output |
* | --- |
* | "A device with this name already exists." |
*
* @param {Auth_Totp_Duplicate_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_totp_duplicate_name = /** @type {((inputs?: Auth_Totp_Duplicate_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_Duplicate_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Gerät mit diesem Namen existiert bereits.")
	return /** @type {LocalizedString} */ ("A device with this name already exists.")
});